<template>
  <div class="min-h-[300px] flex flex-col items-center justify-center">
    <Icon
      :name="
        isSuccess
          ? 'i-heroicons-check-circle'
          : 'i-heroicons-exclamation-triangle'
      "
      class="h-16 w-16 mb-4"
      :class="isSuccess ? 'text-green-500' : 'text-red-500'"
    />
    <p class="text-lg text-center mb-8">
      {{ message }}
    </p>
    <Button
      v-if="!isSuccess"
      color="primary"
      @click="emit('retry')"
    >
      Try Again
    </Button>
  </div>
</template>

<script setup lang="ts">
const props = defineProps<{
  type: 'success' | 'error' | null
  message: string | null
}>()
const emit = defineEmits<{
  retry: []
}>()
const isSuccess = computed(() => props.type === 'success')
</script>
